// Meter Events Report Pie Chart

import React from "react";
import ReactECharts from "echarts-for-react";

interface MeterEventReportPieChartProps {
  data: Array<{
    eventtype: string;
    [key: string]: any;
  }>;
}

const MeterEventReportPieChart: React.FC<MeterEventReportPieChartProps> = ({
  data,
}) => {
  const chartData = data?.map((item) => ({
    name: item.eventtype,
    value: 1,
  }));

  const getColor = (name: string) => {
    switch (name) {
      case "Low Battery":
        return "#9CE976";
      case "Power Outage":
        return "#1976d2";
      case "Tamper Alert":
        return "#db50f2";
      default:
        return null;
    }
  };

  const options = {
    tooltip: {
      trigger: "item",
      backgroundColor: "#181B25",
      borderWidth: 0,
      textStyle: {
        color: "#fff",
        fontSize: 12,
      },
      formatter: "{a} <br/>{b} : {c} kWh ({d}%)",
    },
    series: [
      {
        name: "Events",
        type: "pie",
        radius: "85%",
        avoidLabelOverlap: false,
        data: chartData,
        itemStyle: {
          normal: {
            color: function (params: any) {
              return getColor(params.data.name);
            },
          },
        },
      },
    ],
  };

  return <ReactECharts option={options} style={{ height: "290px" }} />;
};

export default MeterEventReportPieChart;
